import { Component, Inject, OnInit } from '@angular/core'
import { CommonModule, NgOptimizedImage } from '@angular/common'
import { ScopeVersion } from '@core/model/scope-version'
import { FormControl, UntypedFormGroup } from '@angular/forms'
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog'
import { OutputBorders, OutputTemplate } from '@app/features/scope-overview/model/output-template.model'
import { PipesModule } from '@shared/pipe/index.module'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatOptionModule } from '@angular/material/core'
import { MatSelectModule } from '@angular/material/select'
import { ScopeUiInputComponent } from '@shared/components/ui-components/scope-ui-input/scope-ui-input.component'
import { MatInputModule } from '@angular/material/input'
import { ScopeUiDropdownComponent } from '@shared/components/ui-components/scope-ui-dropdown/scope-ui-dropdown.component'
import { SharedModule } from '@shared/shared.module'

export class SetBordersModalConfig {
  currentScope: ScopeVersion
  outputTemplate: OutputTemplate
  confirmCallback: (outputMargins: OutputBorders) => void
}

@Component({
  selector: 'app-set-borders-modal',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatInputModule,
    NgOptimizedImage,
    PipesModule,
    MatFormFieldModule,
    MatIconModule,
    MatOptionModule,
    MatSelectModule,
    ScopeUiInputComponent,
    ScopeUiDropdownComponent,
    SharedModule,
  ],
  templateUrl: './set-borders-modal.component.html',
  styleUrls: ['./set-borders-modal.component.scss'],
})
export class SetBordersModalComponent implements OnInit {
  modalForm: UntypedFormGroup
  currentTemplate: OutputTemplate
  outputMargins: OutputBorders = new OutputBorders()
  selectedStyle: any
  selectedWidth: any

  constructor(@Inject(MAT_DIALOG_DATA) public data: SetBordersModalConfig) {
    this.modalForm = new UntypedFormGroup({ comment: new FormControl('') })
  }

  ngOnInit() {
    this.currentTemplate = this.data.outputTemplate
    if (this.data.outputTemplate.outputTemplateBorders == null) {
      this.outputMargins = new OutputBorders()
    } else {
      this.outputMargins = this.data.outputTemplate.outputTemplateBorders
    }
  }

  applyMarginSettings() {
    this.outputMargins.borderType = 'PAGE_BORDER'
    this.data.confirmCallback(this.outputMargins)
  }

  isFormValid() {
    return this.isOutputMarginsvalid() && this.checkMargin()
  }

  isOutputMarginsvalid() {
    return (
      this.outputMargins.fromTop != null &&
      this.outputMargins.fromBottom != null &&
      this.outputMargins.fromLeft != null &&
      this.outputMargins.fromRight != null
    )
  }

  checkMargin() {
    const marginKeys = ['fromTop', 'fromBottom', 'fromLeft', 'fromRight']
    const isValid = (n: number) => n >= 0 && n <= 31

    return marginKeys.every((key) => isValid(this.outputMargins[key]))
  }
}
